import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'paymentMode'
})
export class DisplayPaymentModePipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
  ) { }

  transform(value: any, args?: any): any {
    let key = '';
    if (value === 1) {
      key = 'mode_of_payment.annual';
    } else if (value === 2) {
      key = 'mode_of_payment.half_yearly';
    } else if (value === 3) {
      key = 'mode_of_payment.quarterly';
    } else if (value === 4) {
      key = 'mode_of_payment.monthly';
    }

    return key === '' ? value : this.translate.get(key);
  }

}
